export default "__VITE_ASSET__Ck1jZ8DV__"